import { createInfo } from '@liveauctioneers/hammer-ui-core/card/components/createInfo';
import { ItemSummary } from '@/types/item/ItemSummary';
import ItemCardEstimate from '@/components/GridItemCard/Card/components/ItemCardEstimate/ItemCardEstimate';

export const EstimateComponent = createInfo<ItemSummary>({
    className: 'line-clamp-0 ',
    useText: ({ isLocked, isTimedPlusAuction, itemId }) => {
        if (isLocked || isTimedPlusAuction) {
            return null;
        }
        return (
            <div className="mb-[2px] mt-xs">
                <ItemCardEstimate itemId={itemId} />
            </div>
        );
    },
});
